import React from 'react'
import { Splide, SplideTrack, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import '@splidejs/react-splide/css/core';

const CareerSlider = () => {
    const slideItem = [1, 2, 3, 4, 5, 6];
    return (
        <div className="_about_nft_slider">
            <Splide
                hasTrack={false}
                options={{
                    type: 'loop',
                    perPage: 3,
                    perMove: 1,
                    arrows: false,
                    pagination: false,
                    focus: 'center',
                    gap: 37,
                    breakpoints: {
                        767: {
                            perPage: 2,
                        },
                        420: {
                            perPage: 1,
                        },
                    }
                }}

            >
                <SplideTrack>
                    {
                        slideItem.map((item, id) =>
                            <SplideSlide key={id}>
                                <div className="_about_nft_slider_card">
                                    <div className="_about_nft_slider_card_cont">
                                        <p className="_about_nft_slider_card_cont_para">But
                                            I must explain to you how all this mistaken
                                            idea of denouncing pleasure and praising pain
                                            was born and I will give you a complete account
                                            of the system, and expound the actual teachings
                                            of the great explorer of the truth, the master-builder
                                            of human happiness.
                                        </p>
                                        <div className="_about_nft_slider_card_info">
                                            <div className="_about_nft_slider_card_info_img" />
                                            <div className="_about_nft_slider_card_info_cont">
                                                <h6 className="_about_nft_slider_card_info_cont_txt">jhon smith
                                                </h6>
                                                <p className="_about_nft_slider_card_info_cont_para">Groth and
                                                    community lead</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SplideSlide>
                        )
                    }
                </SplideTrack>
            </Splide>
        </div>
    )
}

export default CareerSlider